import React, {useState, useEffect} from 'react'
import {connect} from 'react-redux'

import { getIndicators, setIndicator, deleteIndicator, } from 'actions'

// Reactstrap
import {Card, CardTitle, CardHeader, CardBody, FormGroup, Collapse, Label, Input, Spinner} from 'reactstrap'
import {deletePreviousFilter, removePlotPoint,removeUserPlotPoint} from "../../../../actions";

const FilterPanel = ({Indicators: {available_indicators, loading, active_indicators},removeUserPlotPoint, removePlotPoint, deletePreviousFilter,getIndicators, setIndicator, deleteIndicator,}) => {

    const [openedCollapses, setOpenedCollapses] = useState([]);

    useEffect(() => {
        const asyncWrapper = async () => { 
            getIndicators();
        }
        asyncWrapper()
        //eslint-disable-next-line
    }, []);

    const collapsesToggle = (collapse) => {
        if (openedCollapses.includes(collapse)) {
        setOpenedCollapses(openedCollapses.filter((item) => item !== collapse));
        } else {
        openedCollapses.push(collapse);
        setOpenedCollapses([...openedCollapses, collapse]);
        }
    }

    const handleChangeIndicators = (event, nazwa) => {
        if (event.target.checked === false) {
            deleteIndicator(nazwa);
            if(window.location.href.split('/')[window.location.href.split('/').length - 1] ==="comperative_indicators"){
                deletePreviousFilter({[nazwa]: "all"},"none","filterpanl32")
                removePlotPoint(nazwa);
            }
            if(window.location.href.split('/')[window.location.href.split('/').length - 1] ==="my_indicators"){
                deletePreviousFilter({[nazwa]: "all"},"none","filterpanl36")
            removeUserPlotPoint(nazwa)
                }
        } else if (event.target.checked === true) {
            setIndicator(nazwa)
        }
    } 

    const indicatorCheckboxItem = (indicatorType, active_indicators, available_indicators) => {
        return (
            <>
                {!loading && available_indicators.length !== 0 && available_indicators.filter(indicator => indicator.typ ===indicatorType).length !== 0
                    ? ((available_indicators.filter(indicator => indicator.typ ===indicatorType).map(
                        indicator =>
                            { return (
                                    <FormGroup check key={indicator.nazwa} className='wskaznikiCheckBox'>
                                        <Label check>
                                        <Input 
                                        id={indicator.nazwa}
                                        type="checkbox"
                                        defaultChecked={active_indicators.includes(indicator.nazwa)}
                                        onChange={e => handleChangeIndicators(e, indicator.nazwa)}
                                        />
                                        <span className="form-check-sign" />
                                        {`${indicator.nazwa}`}
                                        </Label>
                                    </FormGroup>
                                )}
                                )
                        ))
                    : (<p>Brak dostępnych wskaźników</p>)
                }
            </>
        )
    }
    
    return (
        <Card>
            <CardBody>
                <div
                aria-multiselectable={true}
                className="card-collapse"
                id="accordion"
                role="tablist"
                >
                <CardTitle tag="h5">Wskaźniki</CardTitle>
                {loading 
                ?   <Card className="card-plain mb-2">
                        <CardHeader className='ml-auto mr-auto'>
                            <Spinner color="dark" />
                        </CardHeader>
                        <CardBody className={'ml-auto mr-auto text-center'}>
                                <h5 className="card-category">
                                    Pobieranie danych o dostępnych wskaźnikach
                                </h5>
                        </CardBody>
                    </Card>
              : <>
              <Card className="card-plain ">
                    <CardHeader role="tab">
                    <a
                        aria-expanded={openedCollapses.includes("entity_finance")}
                        // href=""
                        data-parent="#accordion"
                        data-toggle="collapse"
                        onClick={() => collapsesToggle("entity_finance")}
                    >
                        Ekonomiczno-finansowe Podmiotu{" "}
                        <i className="nc-icon nc-minimal-down text-wskazniki" />
                    </a>
                    </CardHeader>
                    <Collapse
                    role="tabpanel"
                    isOpen={openedCollapses.includes("entity_finance")}
                    >
                    <CardBody>
                        {indicatorCheckboxItem('EFP', active_indicators, available_indicators)}
                    </CardBody>
                    </Collapse>
                </Card>
                <Card className="card-plain">
                    <CardHeader role="tab">
                    <a
                        aria-expanded={openedCollapses.includes("opk_finance")}
                        // href=""
                        data-parent="#accordion"
                        data-toggle="collapse"
                        onClick={() => collapsesToggle("opk_finance")}
                    >
                        Ekonomiczno-finansowe   OPK{" "}
                        <i className="nc-icon nc-minimal-down text-wskazniki" />
                    </a>
                    </CardHeader>
                    <Collapse
                    role="tabpanel"
                    isOpen={openedCollapses.includes("opk_finance")}
                    >
                    <CardBody>
                        {indicatorCheckboxItem('EFO', active_indicators, available_indicators)}
                    </CardBody>
                    </Collapse>
                </Card>
                <Card className="card-plain">
                    <CardHeader role="tab">
                    <a
                        aria-expanded={openedCollapses.includes("statistics")}
                        // href=""
                        data-parent="#accordion"
                        data-toggle="collapse"
                        onClick={() => collapsesToggle("statistics")}
                    >
                        Statystyczne{" "}
                        <i className="nc-icon nc-minimal-down text-wskazniki" />
                    </a>
                    </CardHeader>
                    <Collapse
                    role="tabpanel"
                    isOpen={openedCollapses.includes("statistics")}
                    >
                    <CardBody>
                        {indicatorCheckboxItem('S', active_indicators, available_indicators)}
                    </CardBody>
                    </Collapse>
                </Card>
                {/*<Card className="card-plain">*/}
                {/*    <CardHeader role="tab">*/}
                {/*    <a*/}
                {/*        aria-expanded={openedCollapses.includes("human_resource_cost")}*/}
                {/*        // href=""*/}
                {/*        data-parent="#accordion"*/}
                {/*        data-toggle="collapse"*/}
                {/*        onClick={() => collapsesToggle("human_resource_cost")}*/}
                {/*    >*/}
                {/*        Analiza koszów zasobów ludzkich{" "}*/}
                {/*        <i className="nc-icon nc-minimal-down text-wskazniki" />*/}
                {/*    </a>*/}
                {/*    </CardHeader>*/}
                {/*    <Collapse*/}
                {/*    role="tabpanel"*/}
                {/*    isOpen={openedCollapses.includes("human_resource_cost")}*/}
                {/*    >*/}
                {/*    <CardBody>*/}
                {/*        {indicatorCheckboxItem('KZL', active_indicators, available_indicators)}*/}
                {/*    </CardBody>*/}
                {/*    </Collapse>*/}
                {/*</Card>*/}
                
                </>}
            </div>
        </CardBody>
    </Card>
    )
}

const mapStateToProps = state => ({
    Indicators: state.Indicators
});

export default connect(mapStateToProps, {removeUserPlotPoint,removePlotPoint,deletePreviousFilter,getIndicators, setIndicator, deleteIndicator,})(FilterPanel)
